import React from 'react';


import {INavigationProps, Navigation} from '../navigation';
import {Filter, IFilterProps} from './../forms';


export interface IDropDownMenuProps {
    navigation: INavigationProps;
    className?: string;
    languages?: IFilterProps;
    schedule?: IFilterProps;
    questionsFrequency?: IFilterProps;
}

const DropDownMenu = (props: IDropDownMenuProps): JSX.Element => (
    <div className="drop-down-menu__content">
        <Navigation {...props.navigation} className="drop-down-menu__navigation"/>
        {(props.languages || props.schedule || props.questionsFrequency) &&
            <div className="drop-down-menu__settings">
                {props.languages && <Filter {...props.languages} className="drop-down-menu__filter"/>}
                {props.schedule && <Filter {...props.schedule} className="drop-down-menu__filter"/>}
                {props.questionsFrequency && <Filter {...props.questionsFrequency} className="drop-down-menu__filter"/>}
            </div>
        }
    </div>
);

export default DropDownMenu;
